/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOutbound = createReactComponent("outbound", "IconOutbound", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 15l6 -6", key: "svg-1" }],
  ["path", { d: "M11 9h4v4", key: "svg-2" }]
]);

export { IconOutbound as default };
//# sourceMappingURL=IconOutbound.js.map
